// extracted by mini-css-extract-plugin
module.exports = {"title":"increaseCredit_title__QGH1L","formContainer":"increaseCredit_formContainer__2lKWE","inerContainer":"increaseCredit_inerContainer__3PI0D"};